import {useEffect} from 'react';

import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {usePhase} from '../hooks/usePhase.ts';
import {usePhasesSelection} from '../hooks/usePhasesSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

// FNP-999: the steps module landed (FNP-85 sibling story) but this page was
// never updated, so the phase detail view rendered the literal placeholder
// "Steps for this phase will appear here." — leaving every playbook step
// unreachable in the UI despite being fully routed at
// /playbooks/:id/phases/:phaseId/steps/:stepId. StepsPage reads :id and
// :phaseId from the route itself and filters on phaseId.
import {IndexPage as StepsPage} from "../../steps/pages/IndexPage.tsx";

export const EditPage = () => {

    // Route pattern is /playbooks/:id/phases/:phaseId — :id is the playbookId,
    // :phaseId is this phase's id.
    const {id: playbookId, phaseId} = useParams();

    if (typeof playbookId === 'undefined') {
        throw new Error('playbookId is required parameter');
    }

    if (typeof phaseId === 'undefined') {
        throw new Error('phaseId is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`/playbooks/${playbookId}/phases/${phaseId}`);
    }

    const {
        record: phase,
        updateRecord,
    } = usePhase(phaseId);

    const {handleClearSelection} = usePhasesSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!phase) {
        return <PlatformLoader message='Loading phase...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={phase.displayName ? phase.displayName : phase.name ? phase.name : phase.id}
            pageNavigation={<EditPageNavigation component={phase}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 3
                    }}>
                        <Profile record={phase}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 9
                    }}>
                        <StepsPage/>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={phase}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />}


        </FormPageLayout>
    );
};
